import React__default from 'react';
import { classNames, MakeEgdsSizingLength } from '@egds/react-core/utils';
import { EGDSLayoutFlex, EGDSLayoutFlexItem } from '@egds/react-core/layout-flex';
import styles from '../../../../../styles/egds-app-growth-sheet-server-side-render.css';
import { setElementFocus, hasSheetClassName, defineSheetLayout, trapUpperBoundFocus, trapLowerBoundFocus } from '../sheet-server-side-render-utilities/index.esm.js';
import { LayerSheetServerSideRender } from '../layer-sheet-server-side-render/index.esm.js';

/* istanbul ignore file */
const getClassNameList = classNames.bind(styles);
const EGDSCenteredSheetServerSideRender = props => {
  const {
    ariaLabel,
    centeredSheetSize,
    className,
    children,
    height,
    type,
    ariaModal,
    isVisible,
    autoFocus = true,
    onDismiss,
    ...attributes
  } = props;
  const sheetRef = React__default.useRef(null);
  const baseClassName = `egds-${type}-server-sheet`;
  const sheetClassNames = getClassNameList(baseClassName, className, centeredSheetSize === 'small' ? `uitk-centered-sheet-small` : 'uitk-centered-sheet-medium');
  const layerClassName = getClassNameList('egds-server-dialog-layer', 'egds-server-dialog-layer-responsive');
  const sheetStyles = {
    ...(height && {
      [`--uitk-centered-sheet-height`]: `${MakeEgdsSizingLength(height)}`
    })
  };
  // Set focus when initial mount only
  React__default.useEffect(() => {
    if (autoFocus && isVisible) {
      setElementFocus(sheetRef);
    }
    isVisible && hasSheetClassName('add');
  }, [autoFocus, isVisible]);
  // "unmount" hook
  React__default.useEffect(() => () => {
    hasSheetClassName('remove');
  }, []);
  const trapUpperFocus = () => {
    trapUpperBoundFocus();
  };
  const trapLowerFocus = () => {
    trapLowerBoundFocus();
  };
  const {
    hasCloseButton,
    layoutProps,
    closeButtonLayoutProps,
    closeButtonElem,
    childrenElem
  } = defineSheetLayout(children);
  return React__default.createElement(LayerSheetServerSideRender, {
    className: layerClassName,
    onDismiss: onDismiss
  }, React__default.createElement("section", {
    ref: sheetRef,
    className: sheetClassNames,
    tabIndex: -1,
    role: "dialog",
    "aria-modal": ariaModal,
    "aria-label": ariaLabel,
    style: sheetStyles,
    ...attributes
  }, React__default.createElement("div", {
    tabIndex: 0,
    onFocus: trapUpperFocus,
    "aria-hidden": "true"
  }), hasCloseButton && React__default.createElement(EGDSLayoutFlex, {
    ...layoutProps
  }, React__default.createElement(EGDSLayoutFlexItem, {
    ...closeButtonLayoutProps
  }, React__default.createElement("div", null, closeButtonElem)), childrenElem && React__default.createElement(EGDSLayoutFlexItem, null, childrenElem)), !hasCloseButton && childrenElem, React__default.createElement("div", {
    tabIndex: 0,
    onFocus: trapLowerFocus,
    "aria-hidden": "true"
  })));
};
EGDSCenteredSheetServerSideRender.displayName = 'EGDSCenteredSheetServerSideRender';
export { EGDSCenteredSheetServerSideRender };